import { useColorMode } from '@haaretz/s-color-mode';
function isDarkMode(mode) {
    if (mode === 'dark') return true;
    if (mode === 'system') return window.matchMedia('(prefers-color-scheme: dark)').matches;
    return false;
}
export default function useIsDarkMode() {
    const { colorMode } = useColorMode() || {
        colorMode: 'light'
    };
    return isDarkMode(colorMode);
}

//# sourceMappingURL=useIsDarkMode.js.map